import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconModule } from '../../icon/icon.module';
import { InputModule } from '../../input/input.module';
import { SelectModule } from '../../select/select.module';
import { TooltipModule } from '../../tooltip/tooltip.module';
import { DatepickerBaseComponent } from './datepicker-base.component';
import { CalendarDateTooltipPipe } from './datepicker-calendar/date-tooltip/calendar-date-tooltip.pipe';
import { DatepickerCalendarComponent } from './datepicker-calendar/datepicker-calendar.component';
import { DatepickerNavigationComponent } from './datepicker-navigation/datepicker-navigation.component';
import { MonthSelectPipe } from './datepicker-navigation/pipes/month-select.pipe';
import { YearSelectPipe } from './datepicker-navigation/pipes/year-select.pipe';
import { ButtonComponent } from '../../button/button.component';

@NgModule({
	declarations: [
		DatepickerBaseComponent,
		DatepickerCalendarComponent,
		DatepickerNavigationComponent,
		MonthSelectPipe,
		YearSelectPipe,
		CalendarDateTooltipPipe,
	],
	imports: [CommonModule, IconModule, InputModule, ButtonComponent, SelectModule, TooltipModule],
	exports: [DatepickerBaseComponent, CalendarDateTooltipPipe, DatepickerNavigationComponent],
})
export class DatepickerBaseModule {}
